import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import trainIcon from "@icons/ic-train.svg";
import boatIcon from "@icons/ic-boat.svg";
import truckIcon from "@icons/ic-center-truck.svg";
import { daysName } from "@utils/constants";
import {
  CentreInfo,
  FlexRowHeader,
  FlexRow,
  GridRow,
  ButtonData,
  SubTitle,
  SubTitleBold,
  DescriptionData,
} from "./CentreView.styled";
import "../../CompanyView.scss";

const CentreView = (props) => {
  const { t, data } = props;

  const updateDaysName = (days) => {
    const daysArr = days.split(",");
    return daysArr.map((day, i) => [" " + t(daysName[day.toUpperCase()])]);
  };

  return (
    <CentreInfo>
      {!!data?.id && (
        <>
          {" "}
          <FlexRowHeader>
            {!!data.isRoadAccess && (
              <Image
                src={truckIcon}
                alt={t("CENTRE_ACCESS_TOOLTIP_ROAD")}
                title={t("CENTRE_ACCESS_TOOLTIP_ROAD")}
                className="company-centre-view__image-icon-margin-right"
              />
            )}
            {!!data.isTrainAccess && (
              <Image
                src={trainIcon}
                alt={t("CENTRE_ACCESS_TOOLTIP_TRAIN")}
                title={t("CENTRE_ACCESS_TOOLTIP_TRAIN")}
                className="company-centre-view__image-icon-margin-right"
              />
            )}
            {!!data.isBoatAccess && (
              <Image
                src={boatIcon}
                alt={t("CENTRE_ACCESS_TOOLTIP_BOAT")}
                title={t("CENTRE_ACCESS_TOOLTIP_BOAT")}
                className="company-centre-view__image-icon-margin-right"
              />
            )}
            <span style={{ marginRight: "20px" }} />
            {!!data.isBackfill && (
              <ButtonData marginRight="10px" color="#0A4986">
                {t("CENTRE_BACKFILL")}
              </ButtonData>
            )}
            {!!data.isAppointmentForDelivery && (
              <ButtonData marginRight="10px" color="#FF981E">
                {t("CENTRE_NEED_APPOINTMENT")}
              </ButtonData>
            )}
            {!!data.isExtendedHours && (
              <ButtonData marginRight="10px" color="#32A728">
                {t("CENTRE_EXTENDED_HOURS")}
              </ButtonData>
            )}
          </FlexRowHeader>
          <GridRow column="1fr 1fr">
            <div>
              <FlexRow>
                <SubTitleBold width="auto">{t("LOGISTIC_FLOW")} :</SubTitleBold>
                <SubTitle>
                  {data.logisticFlow === null && t("NONE")}
                  {parseInt(data.logisticFlow, 10) === 1 &&
                    t("LOGISTIC_FLOW_ROUND_TRIP")}
                  {parseInt(data.logisticFlow, 10) === 2 &&
                    t("LOGISTIC_FLOW_RETURN_LOAD")}
                  {parseInt(data.logisticFlow, 10) === 3 &&
                    t("LOGISTIC_FLOW_ROUND_TRIP") +
                      "/" +
                      t("LOGISTIC_FLOW_RETURN_LOAD")}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("WORKING_HOURS")} :</SubTitleBold>
              </FlexRow>

              {data?.workingHours.length > 0 &&
                data.workingHours.map((hour) => {
                  return (
                    <FlexRow key={"workinghour-company-" + hour.id}>
                      <SubTitle>
                        {hour.openingHour +
                          " - " +
                          hour.closingHour +
                          " /" +
                          updateDaysName(hour.selectedDays)}
                      </SubTitle>
                    </FlexRow>
                  );
                })}
            </div>

            <div>
              <FlexRow>
                <SubTitleBold>{t("LOADING_UNLOADING_TIME")} :</SubTitleBold>
                <SubTitle>
                  {(data.loadingTime !== null || data.unloadingTime !== null) &&
                    data.loadingTime +
                      " " +
                      t("MINUTES_ABREVIATED") +
                      "/" +
                      data.unloadingTime +
                      " " +
                      t("MINUTES_ABREVIATED")}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("SIMULTANEOUS_LOADS_UNLOADS")} :</SubTitleBold>
                <SubTitle>
                  {(data.simultaneousLoads !== null ||
                    data.simultaneousUnloads !== null) &&
                    data.simultaneousLoads + "/" + data.simultaneousUnloads}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("DOCUMENTS_SPEC")} :</SubTitleBold>
                <SubTitle>
                  {data.documentsSpecificities !== null
                    ? data.documentsSpecificities
                    : ""}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("CENTRE_RECYCLING_CODE")} :</SubTitleBold>
                <SubTitle>
                  {data.recyclingCode !== null
                    ? data?.recyclingCode.code +
                      " - " +
                      data?.recyclingCode.description
                    : "-"}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("DOCUMENTS_DELAY")} :</SubTitleBold>
                <SubTitle>
                  {data.documentsDelays !== null ? data.documentsDelays : ""}
                </SubTitle>
              </FlexRow>
              <FlexRow>
                <SubTitleBold>{t("EXTENDED_HOURS_DETAIL")} :</SubTitleBold>
                <SubTitle>
                  {data.extendedHoursDetails !== null
                    ? data.extendedHoursDetails
                    : ""}
                </SubTitle>
              </FlexRow>
            </div>
          </GridRow>
          <GridRow column="1fr">
            <SubTitleBold>{t("ADDITIONAL_INFORMATION")}</SubTitleBold>
          </GridRow>
          <DescriptionData>
            <div
              dangerouslySetInnerHTML={{
                __html: data.comment,
              }}
            ></div>
          </DescriptionData>
        </>
      )}
    </CentreInfo>
  );
};

CentreView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CentreView);
